<template>
	<el-container id="material_play">
        <div class="location">
			<p>当前位置：</p>
			<p class="item" v-for="(item,index) in location" :key="index" @click="jumpPage(item)">{{item.title}} &gt;</p>
			{{test_tit}}
		</div>
        <div class="material_play"  v-loading="loading">
            <div class="title">{{test_tit}}</div>	
			<div class="guide_con" v-if="playerOptions.sources[0].src!=''">
				<!-- :class="thisPlayVideoSt?'':'prohibit'" -->
        	    <video-player id="courseVideo" class="courseVideo" ref="videoPlayer"
				:playsinline="true"
				:options="playerOptions"></video-player>
        	</div>
        </div>
        
	</el-container>
</template>

<script>
export default {
	name: 'guide'
	,data () {
		return {
			loading:false,
            test_tit:'播放',
			title:'',
            con:`
            `,
			hed:'',
            location:[{
				title:"首页",
				router:"/web/" + this.$store.state.defaultIndex,
				name: this.$store.state.defaultIndex,
                query:{page:this.$store.state.defaultIndex}
			},{
				title:"资料汇总",
				router:"/web/material/",
				name: 'material',
				query:{page:'material'}
			}],
			playerOptions:{		//播放器参数
				// playbackRates: [1.0],		//播放速度  0.7, 1.0, 1.5, 2.0
				autoplay: false,			//为true时，浏览器准备好时开始播放
				muted: false,			//默认情况下将静音
				loop: false,			//视频循环播放
				preload: 'auto',			//建议浏览器在video加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为
				language: 'zh-CN',			//播放器语言
				aspectRatio: '16:9',	//将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例
				fluid: true,	//当true时，video.js player将按比例缩放以适应容器
				flash: { hls: { withCredentials: false } },
        		html5: { hls: { withCredentials: false } },
				sources:[{
					type: "video/mp4",
					src: ""
				}],
				poster: "",
				width: document.documentElement.clientWidth,
				notSupportedMessage:"此视频暂无法播放，请稍后再试", //允许覆盖Video.js无法播放媒体源时显示的默认信息。
				controlBar:{
					timeDivider: true,			//当前时间和持续时间的分隔符
					durationDisplay:true,			//显示持续时间
					remainingTimeDisplay:true,		//是否显示剩余时间功能
					fullscreenToogle:true		//全屏按钮
				},
				playtimes:100, //视频观看起点
			}
		}
	}
	,mounted:function(option){
		this.getlist()
		this.test_tit = this.$route.query.title
		this.location[1].query.mould_id = this.$route.query.mould_id
		// if(this.$route.query.page=="guide"){
		// 	this.hed = "报考指南"
		// 	this.location[1] = {
		// 		title:"报考指南",
		// 		router:"/web/guide/",
		// 		name: 'guide',
		// 		query:{page:'guide'}
		// 	}
		// }else{
		// 	this.hed = "常见问题"
		// 	this.location[1] = {
		// 		title:"常见问题",
		// 		router:"/web/problem/",
		// 		name: 'problem',
		// 		query:{page:'problem'}
		// 	}
		// }
		
	}
	,watch:{
		total(){

		}
	}
	,computed:{

	}
	,methods:{
        //点击当前位置的跳转函数
		jumpPage(args){
			this.$selfjs.jumpPage(this, args)
		},
		//列表
		getlist(){
			this.loading = true
			// console.log(this.$store.state.grade_id);
			let serverSrc=this.global.serverSrc
			,qianzui=this.global.qianzui;
			let token=this.$cookies.get("token")
			let query=this.$route.query;
			this.bijiloading = true
			this.$ajax.get(serverSrc + qianzui + "/material/material_detail",{params:{material_id:this.$route.query.material_id}})
			.then(res=>{
				// console.log(res);
				this.playerOptions.sources[0].src = this.global.oss_website + res.data.data.file_url
				this.loading = false
				// console.log(res.list.data);
			})
		}
	}
	,destroyed:function(){
		window.removeEventListener('scroll',this.getScrollPosition,false)
	}
}
</script>
<!-- scoped单页面有效属性 -->

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/info/material_play.vue